module.exports = __webpack_public_path__ + "static/media/GalleryImage16.d7764879.jpg";